import React, { Component } from 'react';
import { connect } from 'react-redux';
import { identityDispatcher, combineDispatchers, siteSettingsDispatcher } from '../../../store';
import { sessionStore, translate } from '../../../services';
import { PropTypes } from 'prop-types';
import { UserIdentity } from '../../../util';
import { Box, CircularProgress } from '@mui/material';
import { circularProgressClasses } from '@mui/material/CircularProgress';

// in case the website should be availabel through a standard configuration file
// then the defaultSiteHash should be added
// Note that this configuration id should still match the one in breakers.xml or any connected cbol
const defaultSiteHash = '85c1984a-2ebd-4b84-81b8-3e71de460c02';

function extractUid( hash ) {
  const parts = hash.split( '/' );
  const uidIndex = parts.indexOf( 'configurationrequest' ) + 1;
  // work with the potentially saved hash
  return uidIndex === 0 ? null : parts[uidIndex];
}

function getDefaultHash() {
  const hash = UserIdentity.token;
  // site_id is supposed to be defined in index.html
  if (typeof site_id === 'undefined' || site_id === null) {
    // site_id is undefined or null
    return hash || defaultSiteHash;
  } else {
    return site_id || hash || defaultSiteHash;
  }
}

export class ValidatingComponent extends Component {
  componentDidMount() {
    let hash = extractUid( document.location.hash );
    let hasHash = hash !== null;
    let hasQueryString = hasHash && hash.split('?').length > 1;
    if(hash != null && ( hash.indexOf('Apttus') > 0 || hash.indexOf('ELAPTTUS') > 0 || hash.indexOf('BOL') > 0)){ 
      const encodedHash = 'selector?ApttusToken='+btoa(encodeURIComponent(hash.split('selector')[1]));
      this.props.identify( encodedHash || getDefaultHash() ).then( ( result ) => {
        // save it during this session
        UserIdentity.token = hash || UserIdentity.token || getDefaultHash();
        return this.props.get().then( () => this.props.onSuccess( hasHash ) ).catch();
      } ).catch( err => {
        // clear potentially wrong hashes
        UserIdentity.token = null;
        // throw an error
        return this.props.onFailed( err );
      } );
    }else if(hash != null && hasQueryString){
      const hashToDecode = hash.split('?')[1].split('&').find( sh => sh.indexOf('h=') > -1);
      const hookURL = hashToDecode !== undefined ? decodeURIComponent(hashToDecode.split('=')[1]) : '';
      let updatedHash = hash.split('?')[1].split('&');
      if(hookURL != ''){
        updatedHash.pop(sh => sh.indexOf("h="));
        updatedHash.push('h='+hookURL);
      }
      const finalHash = updatedHash.join('&');
      const encodedHash = btoa(encodeURIComponent(hash.split('?')[0])) + '?' + btoa(encodeURIComponent(finalHash));
      this.props.identify( encodedHash ).then( ( result ) => {
        // save it during this session
        UserIdentity.token = hash || UserIdentity.token || getDefaultHash();
        return this.props.get().then( () => this.props.onSuccess( hasHash ) ).catch();
      } ).catch( err => {
        // clear potentially wrong hashes
        UserIdentity.token = null;
        // throw an error
        return this.props.onFailed( err );
      } );
    }else{
      this.props.identify( btoa( encodeURIComponent( hash || getDefaultHash() ) ) ).then( ( result ) => {
        // save it during this session
        UserIdentity.token = hash || UserIdentity.token || getDefaultHash();
        return this.props.get().then( () => this.props.onSuccess( hasHash ) ).catch();
      } ).catch( err => {
        // clear potentially wrong hashes
        UserIdentity.token = null;
        // throw an error
        if ( err && err.response && err.response.status ) {
          // the user should be informed there was an error in the service
          switch ( err.response.status ) {
            case 403:
              // server will throw 403 when the authentication / validation failed
              err.error = 'Your current session has expired, or the authentication service cannot be reached!';
              break;
              case 500:
                err.error =  "The application couldn't authenticate your request due to an internal failure. Please contact helpdesk." ;
              break;
              case 503:
                err.error = "The application couldn't authenticate your request as the service is not reachable. Please contact helpdesk if issue persists." ;
                break;
              case 504:
                err.error = "The application couldn't authenticate your request as the service is busy and unable to process your request. Please try again or contact helpdesk if issue persists.";
                break;
          }
        }
        return this.props.onFailed( err );
      } );
    }
  }
  render() {
    return <div>{translate("Loading, Please Wait...")}</div>;
    // return <div style={{height:"100%", width:"100%",background:"rgba(0,0,0,0.3)", display:"flex", justifyContent:"center", alignItems:"center"}}>
    //   <Box className={"loader"}>
    //     <CircularProgress
    //       variant="determinate"
    //       sx={{
    //         color: (theme) =>
    //           // theme.palette.grey[theme.palette.mode === 'light' ? '1000' : 'white'],
    //           (theme.palette.mode === 'light' ? 'white':'white'),
    //       }}
    //       size={40}
    //       thickness={4}
    //       value={100}
    //     />
    //     <CircularProgress
    //       variant="indeterminate"
    //       disableShrink
    //       sx={{
    //         color: (theme) => (theme.palette.mode === 'light' ? '#FF000F':'#FF000F'),
    //         animationDuration: '1000ms',
    //         position: 'absolute',
    //         left: 0,
    //         [`& .${circularProgressClasses.circle}`]: {
    //           strokeLinecap: 'round',
    //         strokeDasharray: "25px 200px"
    //         },
    //       }}
    //       size={40}
    //       thickness={4}
    //       value={10}
    //     />
    //  </Box>
    //   </div>
   
  }
}

ValidatingComponent.propTypes = {
  failed: PropTypes.func.isRequired,
  identify: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired
};

export const Validating = connect( null, combineDispatchers( identityDispatcher, siteSettingsDispatcher ) )( ValidatingComponent );
